import { useSleepContext } from '../../../core/context/SleepContext';
import Header from '../../../components/Header/Header';
import CompleteExperience from '../../../components/CompleteExperience/CompleteExperience';
import Banner from '../../../components/Banner/Banner';
import SharedApps from '../../../components/SharedApps/SharedApps';
import ArticleList from '../../../components/ArticleList/ArticleList';
import VideoSlider from '../../../components/VideoSlider/VideoSlider';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledPageMainSidebar,
} from '../../../styles/config/pageStyle';

function Sleep() {
  const { banner, experience, sharedApp, article, videos } = useSleepContext();

  return (
    <>
      <Header title="explore" />
      <Banner data={banner} />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <CompleteExperience data={experience} />
            <SharedApps data={sharedApp} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>

      <StyledPageContainer>
        <StyledPageContent reverse>
          <StyledPageMainSidebar>
            <VideoSlider data={videos} />
          </StyledPageMainSidebar>

          <StyledPageMainContent>
            <ArticleList articles={article} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Sleep;
